/**
 * @generated SignedSource<<eb3bdb5e717a094a5373a76f8e2ce1a3>>
 * @relayHash 546354d9795c58c7f4cec3571f3e6ae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 17bdaad9cdc6a0a9bdd038723300f6b082d5eedd61a018c8aa37141dc03e5645

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type RoadmapToggleDependencyInput = {
  dependee: string;
  dependency: string;
};
export type removeRoadmapDependencyMutation$variables = {
  input: RoadmapToggleDependencyInput;
  sourceARI: string;
};
export type removeRoadmapDependencyMutation$data = {
  readonly roadmaps: {
    readonly removeRoadmapDependency: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType?: string | null | undefined;
          readonly statusCode?: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly output: {
        readonly dependee: string;
        readonly dependency: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type removeRoadmapDependencyMutation = {
  response: removeRoadmapDependencyMutation$data;
  variables: removeRoadmapDependencyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceARI"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  },
  {
    "kind": "Variable",
    "name": "sourceARI",
    "variableName": "sourceARI"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "statusCode"
    },
    {
      "kind": "ScalarField",
      "name": "errorType"
    }
  ],
  "type": "RoadmapMutationErrorExtension"
},
v6 = {
  "concreteType": "RoadmapToggleDependencyResponse",
  "kind": "LinkedField",
  "name": "output",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "dependee"
    },
    {
      "kind": "ScalarField",
      "name": "dependency"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "removeRoadmapDependencyMutation",
    "selections": [
      {
        "concreteType": "RoadmapsMutation",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapToggleDependencyPayload",
            "kind": "LinkedField",
            "name": "removeRoadmapDependency",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "removeRoadmapDependencyMutation",
    "selections": [
      {
        "concreteType": "RoadmapsMutation",
        "kind": "LinkedField",
        "name": "roadmaps",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "RoadmapToggleDependencyPayload",
            "kind": "LinkedField",
            "name": "removeRoadmapDependency",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "17bdaad9cdc6a0a9bdd038723300f6b082d5eedd61a018c8aa37141dc03e5645",
    "metadata": {},
    "name": "removeRoadmapDependencyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f2c55864aaec3b444aa411cc582decd9";

export default node;
